/**
 * Phase 6e.3 — count FX contracts that already carry rate data.
 *
 * Used by the Magic Button to decide whether to show the overwrite
 * confirmation modal. Pure function — input the engagement, output a
 * single number.
 *
 * A contract "carries rate data" when ANY of these is true:
 *   • `commencementSpotRate` is a finite number
 *   • `historicalRates` is a non-empty array
 *   • `paymentDateRates` is a non-empty array
 *
 * Non-FX contracts (currency === functionalCurrency) and `null`
 * slots are skipped entirely — the FX sync would never touch them.
 */

import type { EngagementHistoryEntry } from "@/types";

export function detectOverwriteCount(
  engagement: EngagementHistoryEntry,
): number {
  let count = 0;
  for (const c of engagement.contracts) {
    if (c === null) continue;
    if (!c.currency || c.currency === engagement.functionalCurrency) continue;
    const hasSpot =
      typeof c.commencementSpotRate === "number" &&
      Number.isFinite(c.commencementSpotRate);
    const hasHistorical =
      Array.isArray(c.historicalRates) && c.historicalRates.length > 0;
    const hasPayment =
      Array.isArray(c.paymentDateRates) && c.paymentDateRates.length > 0;
    if (hasSpot || hasHistorical || hasPayment) count += 1;
  }
  return count;
}
